
import React, { useState, useEffect, Fragment } from 'react';
import {
    Row,
    Input,
    FormGroup,
    Label,
    CustomInput,
    Button,
    ButtonGroup,
    Form,
    Modal,
    ModalBody,
    InputGroup,
} from 'reactstrap';
import {
    Colxx,
    Separator,
} from '../../../../../../components/common/CustomBootstrap';

import { AxiosAPI, getGroupID } from '../../../../../../helpers/AxiosAPI';
import { sortPropertyListByName } from '../../../../../../helpers/Utils';
import {
    gAPI_Property_List_By_Group, API_TEAMS_APP_INTEGRATION
} from '../../../../../../constants/APIs';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import Validation from '../../../../../../components/Validation';

export default function TeamsAppIntegration({ visible, toggle, id }) {
    const [property, setProperty] = useState([]);
    const [open, setOpen] = useState(false);
    const [msg, setMsg] = useState([]);
    const [inputData, setInputData] = useState({
        groupId: getGroupID(),
        name: '',
        propertyId: '',
        sessionTimeoutInSeconds: 600,
        defaultLanguage: 'en-US',
        clientId: '',
        clientSecret: '',
    });
    const [serviceURLEndpoint, setServiceURLEndpoint] = useState('');
    const [linkCopied, setLinkCopied] = useState(false);

    useEffect(() => {
        if (id !== undefined) {
            const url = process.env.REACT_APP_CHAT_API + `/teams-app?iid=${id}&groupId=${getGroupID()}`;
            setServiceURLEndpoint(url);
            AxiosAPI({
                method: 'get',
                url: `${API_TEAMS_APP_INTEGRATION}/${id}?group_id=${getGroupID()}`,
            })
                .then((res) => {
                    // console.log(res.data)
                    setInputData({
                        ...inputData,
                        name: res.data.name,
                        propertyId: res.data.properties[0],
                        clientId: res.data.channelDetails.clientId,
                        clientSecret: res.data.channelDetails.clientSecret,
                    });
                })
                .catch((err) => console.log('err', err));

            AxiosAPI({
                method: 'get',
                url: `${gAPI_Property_List_By_Group}/?group_id=${getGroupID()}`,
            })
                .then((res) => {
                    setProperty([...res.data]);
                })
                .catch((err) => console.error(err));
        } else {
            AxiosAPI({
                method: 'get',
                url: `${gAPI_Property_List_By_Group}/?group_id=${getGroupID()}`,
            })
                .then((res) => {
                    setProperty([...res.data]);
                })
                .catch((err) => console.error(err));
        }
    }, [id]);

    const handleNameChange = (e) => {
        e.persist();
        setInputData({ ...inputData, Name: e.target.value });
    };

    const handleClientIdChange = (e) => {
        e.persist();
        setInputData({ ...inputData, clientId: e.target.value });
    };

    const handleClientSecretChange = (e) => {
        e.persist();
        setInputData({ ...inputData, clientSecret: e.target.value });
    };

    const handleCheckChange = (e) => {
        if (e.target.checked) {
            setInputData({ ...inputData, propertyId: e.target.value });
        }
        if (!e.target.checked) {
            setInputData({ ...inputData, propertyId: '' });
        }
    };

    const handleSave = async () => {
        if (id !== undefined) {
            AxiosAPI({
                method: 'put',
                url: `${API_TEAMS_APP_INTEGRATION}/${id}?group_id=${getGroupID()}`,
                data: inputData,
            }).then(() => {
                setTimeout(() => {
                    window.location.reload();
                }, 300);
            }
            );
            toggle();
        } else {
            AxiosAPI({
                method: 'post',
                url: API_TEAMS_APP_INTEGRATION,
                data: inputData,
            }).then((res) => {
                if (res.data.HttpStatusCode !== undefined && res.data.HttpStatusCode === 400 && res.data.Messages !== undefined
                    && res.data.Messages !== null && res.data.Messages.length > 0) {
                    setMsg(res.data.Messages);
                    setOpen(true);
                }
                else {
                    setTimeout(() => {
                        window.location.reload();
                    }, 300)
                }
            });
            toggle();
        }
    };
    return (
        <Fragment>
            <Modal isOpen={visible} toggle={toggle}>
                <ModalBody>
                    <Row className="mb-4">
                        <Colxx xxs="12">
                            <div className="text-center">
                                <h6>{id === undefined ? "Add" : "Update"}  Microsoft Teams Integration</h6>
                                <Separator className="mb-3" />
                                <Form>
                                    <FormGroup className="text-left mb-2">
                                        <Label>Integration Name</Label>
                                        <Input
                                            type="text"
                                            name="name"
                                            onChange={handleNameChange}
                                            placeholder="Integration Name"
                                            defaultValue={inputData.name}
                                        />
                                    </FormGroup>
                                    <FormGroup className="text-left mb-2">
                                        <Label>Client Id</Label>
                                        <Input
                                            type="text"
                                            name="clientId"
                                            onChange={handleClientIdChange}
                                            placeholder="Client Id"
                                            defaultValue={inputData.clientId}
                                        />
                                    </FormGroup>
                                    <FormGroup className="text-left mb-2">
                                        <Label>Client Secret</Label>
                                        <Input
                                            type="text"
                                            name="clientSecret"
                                            onChange={handleClientSecretChange}
                                            placeholder="Client Secret"
                                            defaultValue={inputData.clientSecret}
                                        />
                                    </FormGroup>
                                    <FormGroup className="text-left mb-2">
                                        <Label>Service Endpoint Url</Label>
                                        <Input
                                            type="text"
                                            name="serviceurl"
                                            placeholder={serviceURLEndpoint === "" ? "Service endpoint url will be available after you save" : ""}
                                            defaultValue={serviceURLEndpoint}
                                            disabled
                                        />
                                        {serviceURLEndpoint !== "" && (
                                            <Fragment>
                                                <div className='text-center'>
                                                    <CopyToClipboard
                                                        text={serviceURLEndpoint}
                                                        onCopy={() => setLinkCopied(true)}
                                                    >
                                                        <Button
                                                            color="success"
                                                            size="xs"
                                                            style={{ marginTop: '10px' }}
                                                        >
                                                            Copy the URL
                                                        </Button>
                                                    </CopyToClipboard>
                                                    {linkCopied ? <div>Copied.</div> : null}
                                                </div>
                                            </Fragment>
                                        )}
                                    </FormGroup>
                                    <FormGroup className="mb-2">
                                        <div className='my-2 text-center'><h3>Select your property</h3></div>
                                        <div className='integration-property'>
                                            {sortPropertyListByName(property).map((p, index) => {
                                                return (
                                                    <CustomInput
                                                        key={p.id}
                                                        type="radio"
                                                        id={index}
                                                        label={p.name}
                                                        value={p.id}
                                                        name="property"
                                                        checked={
                                                            p.id === inputData.propertyId ? true : false
                                                        }
                                                        onChange={handleCheckChange}
                                                    />
                                                );
                                            })}
                                        </div>
                                    </FormGroup>
                                </Form>
                                <ButtonGroup className="mb-2" style={{ marginTop: '20px' }}>
                                    {id === undefined ? (
                                        <Button color="primary" size="xs" onClick={handleSave}>
                                            Create New Integration
                                        </Button>
                                    ) : (
                                        <Button color="primary" size="xs" onClick={handleSave}>
                                            Update Integration
                                        </Button>
                                    )}

                                    <Button size="xs" color="dark" outline onClick={toggle}>
                                        Cancel
                                    </Button>
                                </ButtonGroup>
                            </div>
                        </Colxx>
                    </Row>
                </ModalBody>
            </Modal>
            <Validation open={open} messages={msg} toggle={() => { setOpen(!open) }}></Validation>
        </Fragment>
    );
}